import '../css/styles.scss';
import { gsap } from 'gsap';
import { Observer } from 'gsap/Observer';
import Main from 'core/controllers/Main';
import Illustration from 'component/Illustration';

gsap.registerPlugin( Observer );

const start = () => {
	Main.init();
	Illustration.init();
};

if ( document.readyState !== 'loading' ) {
	start();
} else {
	document.addEventListener( 'DOMContentLoaded', start );
}
